<template>

  <!-- <div>
    <div v-if="isGranted([permissions.SYSTEM_LOG_MANAGEMENT_VIEW, permissions.SYSTEM_LOG_MANAGEMENT_VIEW_OWN], system)"
         class="card log_management"
         qid="log-management-section"
         id="update_log_management"
    >
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="log-management-table-title" v-if="!showOnTask">
                {{ $t('systems.log_management.title') }}
              </h5>

              <span v-if="!showOnTask">
                <span class="cursor-pointer task-label-open mr-2"
                      v-if="getTask('update_log_management')"
                >
                  <UpdateSingleTaskModal
                      :task="getTask('update_log_management')"
                      @reloadContent="reloadContent"
                      :editIcon="true"
                  ></UpdateSingleTaskModal>
                </span>
                <span v-if="getGuide('update_log_management')"
                      class="cursor-pointer"
                      @click="openHelpCenter(getGuide('update_log_management'))"
                >
                  <font-awesome-icon icon="info-circle"/>
                  {{ $t('system.help_center_label') }}
                </span>
              </span>
            </div>
            <div class="validation-info" qid="view-lm-validation" v-if="!showOnTask">
              <span v-if="validation && validation.validation === 1" qid="log-management-validation-approved">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
                {{ $t('system.approved') }}
              </span>
              <span v-if="validation && validation.validation === 0" qid="log-management-validation-rejected">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
                {{ $t('system.rejected') }}
              </span>
              <span v-if="validation" class="text-muted font-italic">
                {{ $t('system.by') }}
                <span v-if="validation.created_by" qid="view-lm-validation-by">
                  {{ validation.created_by.name }}
                </span>
              </span>
              <span v-if="validation" class="text-muted font-italic">
                {{ $t('system.on') }}
                <span v-if="validation.created_at" qid="view-lm-validation-date">
                  {{ validation.created_at | formatDate }}
                </span>
              </span>
            </div>
          </div>
          <div class="col-sm-6 text-right">
            <ValidationForm
                :object="system"
                type="log_management"
                scope="validate_log_management"
                :checklist="validationOptions"
                :disabledItems="disabledValidationOptions"
                @validationModalClose="handleValidationModalClose"
                v-if="!showOnTask && isGranted([permissions.SYSTEM_LOG_MANAGEMENT_VALIDATE, permissions.SYSTEM_LOG_MANAGEMENT_VALIDATE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
            ></ValidationForm>
            <span class="btn btn-success"
                    @click="showCreateLMModal()"
                    qid="log-management-create-button"
                    v-if="isGranted([permissions.SYSTEM_LOG_MANAGEMENT_CREATE, permissions.SYSTEM_LOG_MANAGEMENT_CREATE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('systems.log_management.create_button') }}
            </span>
          </div>
        </div>

        <table class="table table-responsive-md">
          <thead>
            <tr>
              <th scope="col">
                {{ $t('systems.log_management.table.name') }}
              </th>
              <th scope="col" class="text-center">
                {{ $t('systems.log_management.table.log_collection') }}
              </th>
              <th scope="col" class="text-center">
                {{ $t('systems.log_management.table.log_analysis') }}
              </th>
              <th scope="col">
                {{ $t('system.last_updated') }}
              </th>
              <th width="200"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="object in lmTableItems">
              <td>
                <span v-if="object.log_management && object.log_management.name"
                      @click="openViewModal(object)"
                      qid="log-management-link"
                      class="btn btn-link btn-sm text-left cursor-pointer"
                >
                  {{ object.log_management.name }}
                </span>
              </td>
              <td class="text-center">
                <span v-if="object && object.log_collection">
                  {{ $t('systems.log_management.' + $options.filters.slugify(object.log_collection)) }}
                </span>
              </td>
              <td class="text-center">
                <span v-if="object && object.log_analysis">
                  {{ $t('systems.log_management.' + $options.filters.slugify(object.log_analysis)) }}
                </span>
              </td>
              <td>
                <span>
                  <Avatar :object="object.updated_by" size="xs" class="mr-2" v-if="object.updated_by"></Avatar>
                  {{ object.updated_at | formatDate }}
                </span>
              </td>
              <td align="right">
                <span v-if="object.log_management && object.log_management.name"
                      @click="openViewModal(object)"
                      qid="log-management-link"
                      class="btn btn-view"
                >
                  <font-awesome-icon icon="eye"/>
                </span>
                <span class="btn btn-edit"
                        qid="edit-lm-modal"
                        @click="showEditLMModal(object)"
                        v-if="isGranted([permissions.SYSTEM_LOG_MANAGEMENT_EDIT, permissions.SYSTEM_LOG_MANAGEMENT_EDIT_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span class="btn btn-delete"
                        qid="delete-lm-modal"
                        @click="showLMConfirmDeleteModal(object)"
                        v-if="isGranted([permissions.SYSTEM_LOG_MANAGEMENT_DELETE, permissions.SYSTEM_LOG_MANAGEMENT_DELETE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
              </td>
            </tr>
            <tr v-if="!lmLoading && !lmTableItems.length" qid="no-results-row" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
        <br>
        <div class="text-center mb-4" v-if="!showOnTask">
          <span class="cursor-pointer"
                @click="lmValidationShow = !lmValidationShow"
                qid="log-management-validation-expand"
          >
            <span class="mr-2">{{ $t('system.view_validation_log') }}</span>
            <font-awesome-icon icon="chevron-down" v-if="!lmValidationShow"/>
            <font-awesome-icon icon="chevron-up" v-if="lmValidationShow"/>
          </span>
        </div>
        <hr class="mb-0" v-show="lmValidationShow && !showOnTask">
        <ValidationList
            :object="system"
            type="log_management"
            :reloadList="updateValidationList"
            @validationListUpdated="setValidation"
            v-show="lmValidationShow && !showOnTask"
        ></ValidationList>
      </div>
    </div>


    <b-modal ref="delete-lm" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-lm-title">
          {{ $t('systems.log_management.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('systems.log_management.delete.description') }}
        <span v-if="itemToDelete.log_management">{{ itemToDelete.log_management.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('systems.log_management.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideLMConfirmDeleteModal"
                  qid="delete-lm-cancel-button"
        >
          {{ $t('systems.log_management.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteLM(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-lm-submit-button"
                  v-if="isGranted([permissions.SYSTEM_LOG_MANAGEMENT_DELETE, permissions.SYSTEM_LOG_MANAGEMENT_DELETE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
        >
          {{ $t('systems.log_management.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <b-modal ref="add-log-management" hide-footer @hide="hideCreateLMModal">
      <div class="d-block text-center">
        <h4 qid="add-lm-title">
          {{ $t('systems.log_management.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-lm-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="lmFormSubmit" qid="create-lm-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-lm-pg-label">
              {{ $t('systems.log_management.create.lm_label') }}
            </label>
            <multiselect
                v-model="selectedLM"
                :options="lmItems"
                :placeholder="$t('systems.log_management.create.lm_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @select="resetFields"
                @search-change="loadLM"
                track-by="slug"
                qid="create-lm-form-lm"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedLM && selectedLM.log_collection">
            <label qid="create-lm-log-collection-label">
              {{ $t('systems.log_management.create.lc_label') }}
            </label>
            <multiselect
                v-model="selectedLC"
                :options="lcOptions"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.log_management.create.lc_placeholder')"
                qid="create-ac-form-log-collection"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedLM && selectedLM.log_analysis">
            <label qid="create-ac-log-analysis-label">
              {{ $t('systems.log_management.create.la_label') }}
            </label>
            <multiselect
                v-model="selectedLA"
                :options="laOptions"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.log_management.create.la_placeholder')"
                qid="create-ac-form-log-analysis"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedLM && selectedLM.id">
            <label qid="create-lm-rc-label">
              {{ $t('systems.log_management.create.description_label') }}
            </label>
            <b-form-textarea
              qid="lm-form-description"
              v-model="lmForm.description"
              rows="4"
              max-rows="4"
              :placeholder="$t('systems.log_management.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateLMModal"
                    qid="create-lm-cancel-button"
          >
            {{ $t('systems.log_management.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-lm-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('systems.log_management.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <b-modal ref="edit-lm" hide-footer @hide="hideEditLMModal">
      <div class="d-block text-center">
        <h4 qid="add-lm-title">
          {{ $t('systems.log_management.edit.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-lm-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="formEditLMSubmit" qid="edit-lm-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-lm-label">
              {{ $t('systems.log_management.create.lm_label') }}
            </label>
            <br>
            <span v-if="selectedLM">
              {{ selectedLM.name }}
            </span>
          </b-form-group>
          <b-form-group v-if="selectedLM && selectedLM.log_collection">
            <label qid="create-lm-log-collection-label">
              {{ $t('systems.log_management.create.lc_label') }}
            </label>
            <multiselect
                v-model="selectedLC"
                :options="lcOptions"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.log_management.create.lc_placeholder')"
                qid="create-ac-form-log-collection"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedLM && selectedLM.log_analysis">
            <label qid="create-ac-log-analysis-label">
              {{ $t('systems.log_management.create.la_label') }}
            </label>
            <multiselect
                v-model="selectedLA"
                :options="laOptions"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.log_management.create.la_placeholder')"
                qid="create-ac-form-log-analysis"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedLM && selectedLM.id">
            <label qid="create-lm-rc-label">
              {{ $t('systems.log_management.create.description_label') }}
            </label>
            <b-form-textarea
              qid="lm-form-description"
              v-model="lmForm.description"
              rows="4"
              max-rows="4"
              :placeholder="$t('systems.log_management.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditLMModal"
                    qid="create-lm-cancel-button"
          >
            {{ $t('processes.legal_basis.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-lm-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('processes.legal_basis.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <LogManagementViewModal
        :object="selectedLM"
        v-if="selectedLM"
        :showModal="viewLMModal"
        @closeViewModal="closeViewModal"
    ></LogManagementViewModal>

  </div> -->

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import LogManagementViewModal from '@/views/Systems/LogManagementViewModal.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';

  export default {
    name: 'LogManagementTable',
    data: function() {
      return {
        lmForm: {
          name: '',
          log_analysis: '',
          log_collection: '',
          description: ''
        },
        error: '',
        loadingItems: false,
        selectedLM: [],
        viewLMModal: false,
        editLMModal: false,
        selectedLMSort: '',
        selectedLMDirection: '',
        lmValidationShow: false,
        lmTableItems: [],
        lmLoading: true,
        lmItems: [],
        updateValidationList: false,
        itemToDelete: {},
        object: {},
        lcOptions: [],
        laOptions: [],
        selectedLC: [],
        selectedLA: [],
        validationOptions: [],
        validation: {},
        disabledValidationOptions: [],
        buttonDisabled: false,
        viewLMModal: false,
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      system: {
        type: Object,
        required: true
      },
      showOnTask: {},
      task: {}
    },
    components: {
      Avatar,
      ValidationList,
      ValidationForm,
      LogManagementViewModal,
      UpdateSingleTaskModal
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadLM();
      },
      system: function (value) {
        if (value && value.id) {
          this.system = value;
          this.loadLogManagement();
          this.loadTasks('update_log_management');
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.system.id && this.$store.state.updatedObject.who_am_i == this.system.who_am_i) {
              this.system = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_log_management')
        }
      },
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadLogManagement();
        this.loadTasks('update_log_management');
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.system.who_am_i,
              model_id: this.system.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'systems.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'System' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'System',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      openHelpCenter(object) {
        let topElement = document.getElementById("app");
        if (topElement.classList.contains("guide-collapsed")) {
          topElement.classList.toggle("guide-collapsed");
        }
        if (!topElement.classList.contains("activity-collapsed")) {
          topElement.classList.toggle("activity-collapsed");
        }

        this.$store.commit('storeHelpCenterState', true);
        this.$store.commit('storeActiveGuideScope', object);
      },
      resetFields() {
        this.selectedLA = null
        this.selectedLC = null
      },
      setValidation(object) {
        this.validation = object
      },
      closeViewModal () {
        this.viewLMModal = false;
        this.selectedLM = []
      },
      openViewModal(object) {
        this.selectedLM = object
        this.viewLMModal = true
      },
      openEditLMModal(object) {
        this.selectedLM = object
      },
      showCreateLMModal() {
        this.$refs['add-log-management'].show()
      },
      hideCreateLMModal() {
        this.error = ''
        this.selectedLM = []
        this.selectedLA = []
        this.selectedLC = []
        this.lmForm.description = ''
        this.loadContent();
        this.$refs['add-log-management'].hide()
      },
      showEditLMModal(object) {
        let self = this;
        this.selectedLM = object.log_management

        this.selectedLA = []
        if (object.log_analysis) {
          _.find(this.laOptions, function(item) {
            if (item.value == object.log_analysis) {
              self.selectedLA = item;
            }
          });
        }

        this.selectedLC = []
        if (object.log_collection) {
          _.find(this.lcOptions, function(item) {
            if (item.value == object.log_collection) {
              self.selectedLC = item;
            }
          });
        }

        this.lmForm.description = object.description
        this.object = object
        this.$refs['edit-lm'].show()
      },
      hideEditLMModal() {
        this.error = ''
        this.selectedLM = []
        this.selectedLA = []
        this.selectedLC = []
        this.lmForm.description = ''
        this.loadContent();
        this.$refs['edit-lm'].hide()
      },
      showLMConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-lm'].show()
      },
      hideLMConfirmDeleteModal() {
        this.itemToDelete = {}
        this.loadContent();
        this.$refs['delete-lm'].hide()
      },
      handleValidationModalClose() {
        this.updateValidationList = true
        this.loadContent()
      },
      loadContent() {
        let self = this;
        piincHttp.get('systems/' + this.system.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.system = response.data;
          self.setDisabledValidations();
        }, function() {});
      },
      loadLogManagement() {
        let self = this;
        piincHttp.get('systems/' + this.system.slug + '/log-managements', { params:
          {
            client: this.getClient.slug,
          }
        }).then(function(response) {
          self.lmTableItems = response.data;
          self.lmLoading = false;
        }, function() {});
      },
      confirmDeleteLM(object) {
        let self = this;
        piincHttp.delete('systems/' + this.system.slug + '/log-managements/' + object.id).then(function() {
          self.hideLMConfirmDeleteModal();
          self.loadLogManagement();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('systems.log_management.delete.success'))
        }, function() {});
      },
      lmFormSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedLM && this.selectedLM.id) {
          formData.append("log_management_id", this.selectedLM.id);
        }

        formData.append("system", this.system.slug);
        formData.append("description", this.lmForm.description);

        if (this.selectedLC) {
          formData.append("log_collection", this.selectedLC.value);
        }

        if (this.selectedLA) {
          formData.append("log_analysis", this.selectedLA.value);
        }

        piincHttp.post('/systems/' + this.system.slug + '/log-managements', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('systems.log_management.create.success'))
          self.loadLogManagement();
          self.buttonDisabled = false;
          self.hideCreateLMModal();
          self.$emit('updated');
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.log_management_id) {
              self.error += ' ' + error.data.errors.log_management_id[0]
            }
          }
        })
      },
      formEditLMSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        if (this.selectedLM) {
          this.lmForm.log_management_id = this.selectedLM.id;
        }

        this.lmForm.log_collection = this.selectedLC.value
        this.lmForm.log_analysis = this.selectedLA.value

        piincHttp.put('systems/' + this.system.slug + '/log-managements/' + this.object.id, this.lmForm).then(function() {
          self.hideEditLMModal();
          self.loadLogManagement();
          self.buttonDisabled = false;
          self.$toastr('success', self.$t('systems.log_management.edit.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.log_management_id) {
              self.error += ' ' + error.data.errors.log_management_id[0]
            }
          }
        })
      },
      loadLM(query) {
        let self = this;
        piincHttp.get('log-managements', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.lmItems = response.data.items
          if (self.lmItems && !self.lmItems.length && !query) {
            self.lmItems.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
          if (self.lmItems && self.lmItems.length) {
            self.lcOptions = []
            self.laOptions = []
            _.forEach(self.lmItems[0].logCollectionOptions, function(item) {
              let object = {
                name: self.$t('systems.log_management.' + self.$options.filters.slugify(item)),
                value: item
              }
              self.lcOptions.push(object)
            })
            _.forEach(self.lmItems[0].logAnalysisOptions, function(item) {
              let object = {
                name: self.$t('systems.log_management.' + self.$options.filters.slugify(item)),
                value: item
              }
              self.laOptions.push(object)
            })

          }
          self.setDisabledValidations();
        }, function() {});
      },
      setDisabledValidations() {
        this.disabledValidationOptions = [];
        if (this.system.logManagementsValidation.log_analysis == false) {
          this.disabledValidationOptions.push('Log analysis')
        }
        if (this.system.logManagementsValidation.log_collection == false) {
          this.disabledValidationOptions.push('Log collection')
        }
      }
    },
    created () {
      if (this.getClient && this.getClient.slug) {
        this.loadLM();
      }
      if (this.system && this.system.id) {
        this.loadTasks('update_log_management');
        this.loadLogManagement();
        this.validationOptions = _.cloneDeep(this.system.logManagementValidationOptions)
      }

      this.loadGuides('update_log_management');

    }
  }
</script>
